import React from 'react';
import { Menu } from 'semantic-ui-react';
import { Link } from 'react-router-dom';

const Header = () => (
  <Menu secondary pointing>
    <Menu.Item as={Link} to="/">
      <h1 className="ui blue header">HARTA</h1>
    </Menu.Item>
    <Menu.Item fitted="vertically" position="right">
      <h3>Herramienta de Ayuda a la Redacción de Textos Académicos</h3>
    </Menu.Item>
  </Menu>
);

export default Header;
